import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import background from "../../../assets/background.jpg";
// import logo from "../../../assets/logo.jpg";
import logo21 from "../../../assets/logo21.jpg";
import logoUsaid from "../../../assets/logoUsaid.png";

export default class LandingPageMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data_ready: false,
      display_error: false,
    };
  }

  render() {
    let using_chrome = <div></div>;
    console.log("navigator.userAgent");
    console.log(navigator.userAgent);
    console.log(navigator.userAgent.indexOf("Chrome"));
    if (navigator.userAgent.indexOf("Chrome") < 0) {
      using_chrome = (
        <h1
          className="alert alert-danger"
          role="alert"
          style={{ textAlign: "center" }}
        >
          Please only use Chrome web browser until further notice
        </h1>
      );
    }
    return (
      <div
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          zIndex: "10",
          backgroundColor: "rgba(0,0,0,.2",
        }}
      >
        {using_chrome}
        <div
          className="container"
          style={{
            fontSize: "2rem",
            color: "black",
            zIndex: "20",
            position: "relative",
          }}
        >
          <div className="row">
            <div className="col-12 text-center mt-5 pt-5">
              <h1>The Egyptian STEM Teacher Preparation Program Syllabi</h1>
              <h2>
                Welcome to the STESSA Syllabus App. Here you will find all of
                the University Courses created or about to be be created.
              </h2>
            </div>
          </div>
          <div className="row text-center mt-5">
            <div className="col-7" style={{ textAlign: "right" }}>
              Already a member of the site?
            </div>
            <div className="col-5" style={{ textAlign: "left" }}>
              <NavLink to="/log_in" style={{ color: "#0000ff" }}>
                Log In
              </NavLink>
            </div>
          </div>
          <div className="row text-center mt-2">
            <div className="col-7" style={{ textAlign: "right" }}>
              Forgot Password?
            </div>
            <div className="col-5" style={{ textAlign: "left" }}>
              <NavLink to="/forgot_pw" style={{ color: "#0000ff" }}>
                Reset Password
              </NavLink>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-7" style={{ textAlign: "right" }}>
              If not:
            </div>
            <div className="col-5" style={{ textAlign: "left" }}>
              <NavLink to="/sign_up" style={{ color: "#0000ff" }}>
                Sign Up
              </NavLink>
            </div>
          </div>
          <div className="logos-container row">
            <div className="col-6">
              <img
                src={logo21}
                className="rounded float-left"
                style={{
                  width: 250,
                  height: 100,
                  zIndex: "11",
                  position: "absolute",
                  top: 60,
                }}
                alt="21pstem"
              />
            </div>
          </div>
          <div
            style={{ zIndex: "11", position: "absolute", top: -20, left: 0 }}
          >
            <img
              src={logoUsaid}
              className="rounded float-left"
              style={{ width: 300, height: 117 }}
              alt="usaid"
            />
          </div>
        </div>
        {using_chrome}
      </div>
    );
  }
}
